import React from "react";
import { PlateElement, type PlateElementProps } from "platejs/react";
import { BlockRowContext } from "../../LogCard";

/**
 * NOTA — a free-text production note. Editable text, distinct from a PLECA so
 * it reads as guidance rather than on-screen graphic.
 */
export function NotaBlock(props: PlateElementProps) {
  const blockRowCtx = React.useContext(BlockRowContext);
  return (
    <PlateElement {...props} style={{ margin: "8px 0" }}>
      <div
        style={{
          borderLeft: "3px solid #64748b",
          background: "rgba(100,116,139,0.10)",
          borderRadius: 4,
          padding: "8px 12px",
        }}
      >
        <div
          contentEditable={false}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 6,
            fontSize: "0.6rem",
            fontWeight: 800,
            letterSpacing: 1.5,
            color: "#94a3b8",
            marginBottom: 4,
          }}
        >
          {blockRowCtx?.handleRef && (
            <span
              ref={blockRowCtx.handleRef as any}
              title="Arrastrar"
              style={{ display: "inline-flex", cursor: "grab", color: "#64748b" }}
            >
              <i className="bx bx-grid-vertical" style={{ fontSize: "1rem" }} />
            </span>
          )}
          RECURSO
        </div>
        <div
          style={{
            color: "#cbd5e1",
            fontSize: "0.85rem",
            lineHeight: 1.5,
            outline: "none",
          }}
        >
          {props.children}
        </div>
      </div>
    </PlateElement>
  );
}
